<template>
  <component :is="component" @setComponent="setComponent"></component>
</template>

<script>
import PaymentIntegrations from './PaymentIntegrations.vue';
import EmailsIntegrations from './EmailsIntegrations.vue';
export default {
  components: {
    PaymentIntegrations,
    EmailsIntegrations
  },
  data() {
    return {
      component: 'PaymentIntegrations',
    };
  },
  methods: {
    setComponent(payload) {
      this.component = payload
    },
  }
}
</script>

<style lang="sass" scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/MembersArea/Integrations.vue